import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarModule, CoreModule } from '@sag-ui';

const modules = [RouterModule, TranslateModule, SnackbarModule, CoreModule.forRoot('shs')];

@NgModule({
    declarations: [],
    imports: [CommonModule, ...modules],
    exports: [modules]
})
export class SharedModule {}
